import { MenuType } from "@/store/domains/user/types";
import { useStore } from "@/store";

const menuTypeLocalStorageKey = "OccMenuType";

export const saveMenuTypeToLocalStorage = (menuType: MenuType) => {
  localStorage.setItem(menuTypeLocalStorageKey, menuType);
};

export const clearMenuTypeInLocalStorage = () => {
  localStorage.removeItem(menuTypeLocalStorageKey);
};

export const restoreMenuTypeFromLocalStorage = () => {
  const savedMenuType = localStorage.getItem(menuTypeLocalStorageKey);
  if (!savedMenuType) {
    return;
  }

  const store = useStore();
  store.commit("domains/user/changeMenuType", savedMenuType);
};
